import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">AquaClean Pro</h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Professional wet area cleaning specialists. 30 years of cleaning experience serving Karnup and surrounding areas.
            </p>
            <div className="flex gap-2 text-sm text-gray-400">
              <span className="bg-teal-600/20 px-3 py-1 rounded-full text-teal-400">100% Satisfaction Focus</span>
              <span className="bg-teal-600/20 px-3 py-1 rounded-full text-teal-400">Locally Owned</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-teal-400 transition-colors duration-300">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-teal-400 transition-colors duration-300">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-teal-400 transition-colors duration-300">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('why-choose')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-teal-400 transition-colors duration-300">
                  Why Choose Us
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-teal-400 transition-colors duration-300">
                  Book Appointment
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-teal-400 flex-shrink-0" />
                <a href="tel:+61475854327" className="hover:text-teal-400 transition-colors duration-300">
                  +61 475 854 327
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-teal-400 flex-shrink-0" />
                <a href="mailto:aquacleanprowa@gmail.com" className="hover:text-teal-400 transition-colors duration-300">
                  aquacleanprowa@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-teal-400 flex-shrink-0 mt-1" />
                <span>Servicing Karnup, Mandurah, Rockingham, Baldivis & nearby suburbs</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} AquaClean Pro. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors duration-300">
              Terms of Service
            </a>
            <a href="/admin" className="text-gray-600 hover:text-teal-400 transition-colors duration-300 text-xs">
              ⚙️
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
